module.exports = __webpack_public_path__ + "img/67.7e6f30bf.png";